import {
  fetchAddressCountries,
  getOnboardingModel,
} from '../../services/entities/onboardingService'
import { fetchPlans } from '../../services/plansService'
import { params } from '../../localData'
import funcs from '../../utils/formatting'
import { PLAN_TYPES } from '../../consts'
import { isObjEmpty } from '../../services/UtilService'

const OB_FLOW_STEPS = 7
export const onboardingModule = {
  namespaced: true,
  state: {
    data: getOnboardingModel(),
  },
  mutations: {
    setKeyValue(state, payload) {
      let { prop, value } = payload
      state.data = { ...state.data, [prop]: value }
    },
  },
  getters: {
    progressBarWidth({ data }) {
      if (data.currStep >= OB_FLOW_STEPS) {
        return '100%'
      }
      let width = (100 / OB_FLOW_STEPS) * JSON.parse(data.currStep)
      return width.toString() + '%'
    },
    data({ data }) {
      // Return shallow copy, to avoid mutation out of module scope
      return { ...data }
    },
    isPartnerFlow({ data }) {
      return data.isPartnerFlow
    },
    partnerName({ data: { partnerName } }) {
      return partnerName
    },
    isMobile({ data }) {
      return data.isMobile
    },
    partnerToken({ data }) {
      return data.partnerToken
    },
    currStep({ data }) {
      return data.currStep
    },
    addressCountries({ data }) {
      return data.addressCountries
    },
    mfaStateToken({ data }) {
      return data.mfaStateToken
    },
    addressCountriesWithUS({ data }) {
      return {
        ...data.addressCountries,
        ['United States']: {
          code: 'US',
          subDivisions: params.states.map((state) => {
            return {
              name: state.title,
              code: state.id,
            }
          }),
        },
      }
    },
    plans({ data }) {
      return data.plans
    },
    plansPricing({ data: { plans } }) {
      if (!plans || isObjEmpty(plans)) return {}
      return plans.reduce(
        (acc, plan) => {
          if (PLAN_TYPES[plan.type]) {
            acc[plan.type] = funcs.formatNumberToCurrency(plan.price)
          }
          return acc
        },
        { [PLAN_TYPES.BASIC]: funcs.formatNumberToCurrency(0) }
      )
    },
    plansAnnualDataMap({ data: { plans } }) {
      if (!plans || isObjEmpty(plans)) return {}
      return plans.reduce((acc, { type, annualData }) => {
        acc[type] = annualData
        return acc
      }, {})
    },
    tempRequireAuth({ data }) {
      return data.tempRequireAuth
    },
  },
  actions: {
    async loadAddressCountries({
      commit,
      state,
      rootState: {
        customer: {
          data: { accessToken, customerId },
        },
      },
    }) {
      if (
        state.data.addressCountries &&
        !isObjEmpty(state.data.addressCountries)
      ) {
        return
      }
      const countries = await fetchAddressCountries({
        accessToken: accessToken,
        customerId: customerId,
      })
      commit('setKeyValue', {
        prop: 'addressCountries',
        value: countries,
      })
    },
    async loadPlansData({
      commit,
      state,
      rootState: {
        customer: {
          data: { accessToken, customerId, availablePromoCodes },
        },
      },
    }) {
      if (state.data.plans && state.data.plans.length) {
        return
      }
      const plans = await fetchPlans({
        accessToken,
        customerId,
        promoData: availablePromoCodes,
      })
      commit('setKeyValue', {
        prop: 'plans',
        value: plans,
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/RF_store/modules/onboarding.module.js